import { Col, Form, FormProps, Spin } from 'antd';
import { useState } from 'react';

import { openErrorNotification, openSuccessNotification } from 'shared/lib';
import { UiInput, UiSelect } from 'shared/ui/ui-kit';

import {
  ManualCommandType,
  MANUAL_COMMAND_RESET_TYPE,
  ResetType,
} from 'entities/manual-command';

import { ADD_ERROR, ADD_SUCCESS } from '../../../consts';

import {
  FormButtonsContainer,
  FormItem,
  FormRow,
  StyledButton,
} from '../../../../../common-styles';

import { useSendCommandMutation } from '../../../../../redux/services/private-methods';
import { VALIDATION_RULE } from '../../../../../constants/validation-rules';

interface FormData {
  chargePointName: string;
  resetType: ResetType | '';
}

interface RebootFormProps {
  commandType: ManualCommandType;
  cpName: string;
  closeModal: () => void;
  isDisabled?: boolean;
}

export function RebootForm({
  closeModal,
  isDisabled = true,
  commandType,
  cpName,
}: RebootFormProps) {
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(isDisabled);

  const [sendCommandTrigger, { isLoading }] = useSendCommandMutation();

  const [form] = Form.useForm();

  const onValuesChange: FormProps<FormData>['onValuesChange'] = (
    _,
    allValues
  ) => {
    if (allValues.chargePointName !== '' && allValues.resetType !== '') {
      setIsSubmitDisabled(false);
    } else {
      setIsSubmitDisabled(true);
    }
  };

  const handleSubmit = async (values: FormData) => {
    const req = {
      command: commandType,
      cpName: values.chargePointName,
      body: { resetType: values.resetType },
    };

    try {
      const res = await sendCommandTrigger(req).unwrap();

      res.statusCode === 0
        ? openSuccessNotification(ADD_SUCCESS)
        : openErrorNotification(res.statusDescription);
    } catch (e) {
      openErrorNotification(ADD_ERROR);
    } finally {
      closeModal();
    }
  };

  const getInitialValues = () => {
    return {
      chargePointName: cpName,
      resetType: '',
    };
  };

  return (
    <Form
      form={form}
      layout="vertical"
      autoComplete="off"
      onFinish={handleSubmit}
      onValuesChange={onValuesChange}
      initialValues={getInitialValues()}
    >
      <FormRow gutter={10}>
        <Col span={12}>
          <FormItem
            label="Наименование ЭЗС"
            name="chargePointName"
            rules={[VALIDATION_RULE.REQUIRED]}
          >
            <UiInput />
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem
            label="Тип сброса"
            name="resetType"
            rules={[VALIDATION_RULE.REQUIRED]}
          >
            <UiSelect
              options={Object.entries(MANUAL_COMMAND_RESET_TYPE).map(
                ([value, label]) => ({
                  value,
                  label,
                })
              )}
            />
          </FormItem>
        </Col>
      </FormRow>
      <FormButtonsContainer>
        <Spin spinning={isLoading}>
          <StyledButton
            htmlType="submit"
            type="primary"
            disabled={isSubmitDisabled}
          >
            Добавить
          </StyledButton>
        </Spin>
        <StyledButton htmlType="button" type="default" onClick={closeModal}>
          Отмена
        </StyledButton>
      </FormButtonsContainer>
    </Form>
  );
}
